import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Dealer } from '../shared/dealer.model';
import { DealerService } from '../shared/dealer.service';

@Component({
  selector: 'app-edit-dealer',
  templateUrl: './edit-dealer.component.html',
  styleUrls: ['./edit-dealer.component.css']
})
export class EditDealerComponent implements OnInit {

  constructor(public dealerService: DealerService, public dialogRef: MatDialogRef<EditDealerComponent> ) { }

  ngOnInit() {
    this.resetForm();
  }

  resetForm(form?: NgForm) {
    if (form != null) {
      form.resetForm();
      this.dealerService.dealerData = {
        id: null,
        displayLocation: '',
        displayName: '',
        distance: 0,
        feedId: '',
        location: '',
        maxCpc: 0,
        name: '',
        postCode: '',
        siteLinks: '',
        address: '',
        email: '',
        keyContact: '',
        maxBidprice: 0,
        parentDealerid: 0,
        status: 0     
      }
    }
  }
  onClose() { 
    this.dialogRef.close();
  }

  onCancel() {
    this.dealerService.onCancel();
    this.onClose();
  }
   
  onSubmit(form: NgForm) {
    if (this.dealerService.dealerData.id == null) {
      this.dealerService.addDealer({
        id: 0,
        name: form.value.name,
        location: form.value.location,
        postCode: form.value.postCode,
        distance: form.value.distance,
        maxCpc: form.value.maxCpc,
        displayName: form.value.displayName,
        displayLocation: form.value.displayLocation,
        siteLinks: form.value.siteLinks,
        feedId: form.value.feedId,
        address: form.value.address,
        email: form.value.email,
        keyContact: form.value.keyContact,
        maxBidprice: form.value.maxBidprice,
        parentDealerid: form.value.parentDealerid,
        status: form.value.status
      });
    }
    else {
      this.dealerService.updateDealer({
        id: this.dealerService.dealerData.id,
        name: form.value.name,
        location: form.value.location,
        postCode: form.value.postCode,
        distance: form.value.distance,
        maxCpc: form.value.maxCpc,
        displayName: form.value.displayName,
        displayLocation: form.value.displayLocation,
        siteLinks: form.value.siteLinks,
        feedId: form.value.feedId,
        address: form.value.address,
        email: form.value.email,
        keyContact: form.value.keyContact,
        maxBidprice: form.value.maxBidprice,
        parentDealerid: form.value.parentDealerid,
        status: form.value.status
      });
    }
    this.onClose();
  }
}
